import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const WorkflowmodelSchema = createComponentSchema(
  'Workflowmodel',
  z.object({
    workflowmodelUuid: z.string().optional(),
    returnUrl: z.string().optional(),
    returnOnFinish: z.boolean().optional()
  })
)

export default WorkflowmodelSchema
